module.exports = __webpack_public_path__ + "img/cup-blue.c0343973.svg";